import { Controller } from 'stimulus';

// Page-level coordinator for /admin/feature_toggles. Owns the recent
// audit-log table (`auditTable` target) so per-row toggle controllers
// can prepend a new entry after a successful mutation without each row
// reaching across the DOM. Connected via Stimulus outlets — see
// `toggle_controller.js`.
export default class extends Controller {
  static targets = ['auditTable'];

  // Prepend an audit-log <tr> (already rendered server-side) to the top
  // of the audit log table. No-op if the empty-state partial is showing
  // instead of a real table — the next page load will pick it up.
  prependAuditEntry(html) {
    if (!this.hasAuditTableTarget) return;
    if (!html || !html.trim()) return;

    this.auditTableTarget.insertAdjacentHTML('afterbegin', html);

    // Brief visual cue so the admin's eye lands on the new row.
    const inserted = this.auditTableTarget.firstElementChild;
    if (inserted) {
      inserted.style.transition = 'background-color 1.4s ease';
      inserted.style.backgroundColor = '#fff7e0';
      window.setTimeout(() => { inserted.style.backgroundColor = ''; }, 1500);
    }
  }
}
